import * as z from "zod";

export const updateCommentsoldIntegration = {
  name: "updateCommentsoldIntegration" as const,
  input: z.object({
    useCommentsoldProductInfoForShopifyFulfillments: z.boolean().optional(),
    preferVariantSku: z.boolean().nullish(),
    fsrTitleText: z.string().optional(),
    fsrPositiveSubtext: z.string().optional(),
  }),
  output: z.void(),
};
